<template>
  <section class="bak-color">
    <div class="container clearfix">
            <div class="services">
                  <h3>Devices Contributing Pollution Data</h3>
                  <ul class="col-xs-12">
                      <li class="col-lg-6 col-xs-6">
                        <a href="http://originstech.com/" target="_blank"><img src="../assets/images/origins.png" alt="Origins Laser Egg"></a>
                          <a href="http://originstech.com/" target="_blank"><h6>Origins Laser Egg</h6></a>
                      </li>
                      <li class="col-lg-6 col-xs-6">
                        <a href="https://airvisual.com/node" target="_blank"><img src="../assets/images/airvisual.png" alt="AirVisual Node"></a>
                          <a href="https://airvisual.com/node" target="_blank"><h6>AirVisual Node</h6></a>
                      </li>

                  </ul>
                  <div class="clear"></div>
              </div>
           </div>
  </section>
</template>
<script>
export default {
  name: 'airvisual',
  data () {
    return {
    }
  },
  methods : {

  }
}
</script>



// WEBPACK FOOTER //
// AirVisual.vue?3abf1608